var $69db28e4ed958394$exports = {};
$69db28e4ed958394$exports = {
    "removeButtonLabel": `Eemalda`,
    "removeDescription": `Sildi eemaldamiseks vajutage kustutusklahvi Delete.`
};


export {$69db28e4ed958394$exports as default};
//# sourceMappingURL=et-EE.mjs.map
